import { Button } from '@material-ui/core';
import React from 'react';
import { HealthCheckGroup } from 'services/health';
import { HealthCheckState } from 'types/health';
import HealthGroup from './HealthGroup';
import { GroupsWrapper, SummaryActions, SummaryBar, SummaryCounter } from '../styles';

export type HealthCourseContentProps = {
  groups: HealthCheckGroup[];
  summaryText: string;
  totalChecks: number;
  hasStarted: boolean;
  allCompleted: boolean;
  checksNeedingRetryCount: number;
  checkStates: Record<string, HealthCheckState>;
  onStart: () => void;
  onRetryAll: () => void;
  onRetryIncomplete: () => void;
  onRetryCheck: (checkId: string) => void;
};

const HealthCourseContent: React.FC<HealthCourseContentProps> = ({
  groups,
  summaryText,
  totalChecks,
  hasStarted,
  allCompleted,
  checksNeedingRetryCount,
  checkStates,
  onStart,
  onRetryAll,
  onRetryIncomplete,
  onRetryCheck,
}) => {
  return (
    <>
      <SummaryBar>
        <SummaryCounter>{summaryText}</SummaryCounter>
        <SummaryActions>
          {!hasStarted && totalChecks > 0 && (
            <Button variant="contained" size="small" color="primary" onClick={onStart}>
              Run all checks
            </Button>
          )}
          {hasStarted && allCompleted && (
            <Button variant="outlined" size="small" onClick={onRetryAll}>
              Re-run all checks
            </Button>
          )}
          {hasStarted && allCompleted && checksNeedingRetryCount > 0 && (
            <Button variant="outlined" size="small" onClick={onRetryIncomplete}>
              Re-run incomplete
            </Button>
          )}
        </SummaryActions>
      </SummaryBar>
      <GroupsWrapper>
        {groups.map((group) => (
          <HealthGroup key={group.title} group={group} states={checkStates} onRetry={onRetryCheck} />
        ))}
      </GroupsWrapper>
    </>
  );
};

export default HealthCourseContent;
